import React, { useCallback, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

export const useGoogleReCaptcha = settings => {
  const reCaptchaRef = useRef(null);
  const { recaptcha } = settings;
  const reCaptchaVersion = recaptcha?.version;

  const reCaptchaElement = reCaptchaVersion === '2'
    ? <ReCAPTCHA ref={reCaptchaRef} sitekey={recaptcha.siteKeyV2} size="invisible" />
    : null;

  const getReCaptchaToken = useCallback(async () => {
    if (reCaptchaVersion === '2') {
      return reCaptchaRef.current.executeAsync();
    }

    if (reCaptchaVersion === '3') {
      await window.grecaptchaReady;

      await new Promise(resolve => {
        window.grecaptcha.ready(resolve);
      });

      return window.grecaptcha.execute(recaptcha.siteKeyV3, { action: 'submit' });
    }

    return undefined;
  }, [recaptcha?.siteKeyV3, reCaptchaVersion]);

  const resetReCaptcha = useCallback(async () => {
    if (reCaptchaVersion === '2') {
      await reCaptchaRef.current.reset();
    }
  }, [reCaptchaVersion]);

  return { getReCaptchaToken, reCaptchaElement, resetReCaptcha };
};
